<template>
  <loading v-if="loadingGetData" />
  <error-messages
    v-else-if="!loadingGetData && errorMessagesGetData.length > 0"
    :messages="errorMessagesGetData"
  />
  <b-form v-else @submit.prevent="editInfoSubmit">
    <error-messages
      v-if="errorMessagesEdit.length > 0"
      :messages="errorMessagesEdit"
    />
    <b-row>
      <b-col sm="12" md="6" xl="4">
        <b-card>
          <b-row>
            <b-col lg="12" class="d-flex flex-column align-items-center">
              <b-avatar size="150px" :src="profilePicture" alt="عکس پروفایل" />
              <div class="d-flex mt-3">
                <b-form-group>
                  <b-form-input
                    type="text"
                    :value="form.firstName.value"
                    placeholder="نام"
                    :state="validFirstName"
                    @update="firstNameChangeHandler"
                  />
                  <b-form-invalid-feedback
                    class="text-right"
                    :state="validFirstName"
                  >
                    {{ form.firstName.error }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                  <b-form-input
                    type="text"
                    :value="form.lastName.value"
                    placeholder="نام‌خانوادگی"
                    :state="validLastName"
                    @update="lastNameChangeHandler"
                  />
                  <b-form-invalid-feedback
                    class="text-right"
                    :state="validLastName"
                  >
                    {{ form.lastName.error }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </b-col>
            <b-col lg="12">
              <div class="d-flex justify-content-between mt-3">
                <b-button
                  variant="danger"
                  :to="`/admin/user/${this.$route.params.userId}/details`"
                >
                  لغو ویرایش
                </b-button>
                <loading-btn
                  :disabled="disabled || loadingEdit"
                  :loading="loadingEdit"
                  variant="primary"
                  type="submit"
                >
                  تایید ویرایش
                </loading-btn>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="12" md="6" xl="8">
        <b-card style="margin-bottom: 30px" title="مشخصات" title-tag="h5">
          <b-row>
            <b-col
              v-for="(item, i) in profileList"
              :key="i"
              sm="6"
              md="12"
              xl="6"
            >
              <div class="d-flex align-items-center mb-3">
                <b-icon
                  :icon="item.icon"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                />
                <div class="d-flex flex-column">
                  <span
                    class="display: flex"
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    {{ item.type }}
                  </span>
                  <span>
                    {{ item.value }}
                  </span>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="d-flex align-items-center mb-3">
                <b-icon
                  icon="cash"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                />
                <div class="d-flex flex-column">
                  <span
                    class="d-flex"
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    اعتبار حساب
                  </span>
                  <b-form-input
                    type="text"
                    :value="form.balance.value"
                    style="direction:ltr"
                    :state="validBalance"
                    @update="balanceChangeHandler"
                  />
                  <b-form-invalid-feedback
                    class="text-right"
                    :state="validBalance"
                  >
                    {{ form.balance.error }}
                  </b-form-invalid-feedback>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="d-flex align-items-center mb-3">
                <b-icon
                  icon="envelope-fill"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                />
                <div class="d-flex flex-column">
                  <span
                    class="d-flex"
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    ایمیل
                  </span>
                  <b-form-input
                    type="text"
                    :value="form.email.value"
                    style="direction:ltr"
                    :state="validEmail"
                    @update="emailChangeHandler"
                  />
                  <b-form-invalid-feedback
                    class="text-right"
                    :state="validEmail"
                  >
                    {{ form.email.error }}
                  </b-form-invalid-feedback>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="d-flex align-items-center mb-3">
                <b-icon
                  icon="telephone-fill"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                />
                <div class="d-flex flex-column">
                  <span
                    class="display: flex"
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    تلفن
                  </span>
                  <span>
                    {{ form.phoneNumber.value }}
                  </span>
                </div>
              </div>
              <!-- <div class="d-flex align-items-center mb-3">
                <b-icon
                  icon="telephone-fill"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                />
                <div class="d-flex flex-column">
                  <span
                    class="d-flex"
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    تلفن
                  </span>
                  <b-form-input
                    type="text"
                    :value="form.phoneNumber.value"
                    style="direction:ltr"
                    :state="validPhoneNumber"
                    @update="phoneNumberChangeHandler"
                  />
                  <b-form-invalid-feedback
                    class="text-right"
                    :state="validPhoneNumber"
                  >
                    {{ form.phoneNumber.error }}
                  </b-form-invalid-feedback>
                </div>
              </div> -->
            </b-col>
            <b-col cols="12" xl="6">
              <div class="d-flex align-items-center mb-3">
                <b-icon
                  icon="lock-fill"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                />
                <div class="d-flex flex-column">
                  <span
                    class="d-flex"
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    رمز عبور
                  </span>
                  <b-form-input
                    type="text"
                    v-model="form.password.value"
                    style="direction:ltr"
                    :state="validPassword"
                    @update="passwordChangeHandler"
                  />
                  <b-form-invalid-feedback
                    class="text-right"
                    :state="validPassword"
                  >
                    {{ form.password.error }}
                  </b-form-invalid-feedback>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="d-flex align-items-center mb-3">
                <b-icon
                  icon="lock-fill"
                  font-scale="2"
                  variant="warning"
                  class="ml-3"
                />
                <div class="d-flex flex-column">
                  <span
                    class="d-flex"
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    تکرار رمز عبور
                  </span>
                  <b-form-input
                    type="text"
                    v-model="form.confirmPassword.value"
                    style="direction:ltr"
                    :state="validConfirmPassword"
                    @update="confirmPasswordChangeHandler"
                  />
                  <b-form-invalid-feedback
                    class="text-right"
                    :state="validConfirmPassword"
                  >
                    {{ form.confirmPassword.error }}
                  </b-form-invalid-feedback>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { userDetailsAdmin, userEditAdmin } from "@/services/user";
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn.vue";
import Loading from "@/components/Loading/Loading.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  name: "UserEdit",
  components: { LoadingBtn, Loading, ErrorMessages },
  data() {
    return {
      // list data
      loadingGetData: false,
      errorMessagesGetData: [],
      profileList: [
        {
          id: "username",
          type: "نام کاربری",
          icon: "person-fill",
          value: ""
        },
        {
          id: "registerDateTime",
          type: "تاریخ ثبت نام",
          icon: "calendar2-check-fill",
          value: ""
        },
        {
          id: "lastLoginDateTime",
          type: "تاریخ آخرین لاگین",
          icon: "calendar-date",
          value: ""
        }
      ],
      // edit data
      loadingEdit: false,
      errorMessagesEdit: [],
      form: {
        firstName: { value: "", error: "" },
        lastName: { value: "", error: "" },
        email: { value: "", error: "" },
        phoneNumber: { value: "", error: "" },
        balance: { value: "", error: "" },
        isEmailConfirmed: { value: false, error: "" },
        isPhoneNumberConfirmed: { value: false, error: "" },
        password: { value: "", error: "" },
        confirmPassword: { value: "", error: "" }
      },
      isActive: false,
      role: 1,
      profilePicture: "",
      validEmail: true,
      validPhoneNumber: true,
      validFirstName: true,
      validLastName: true,
      validBalance: true,
      validPassword: true,
      validConfirmPassword: true,
      disabled: false
    };
  },
  mounted() {
    this.getUserDetailsAdmin();
  },
  methods: {
    getUserDetailsAdmin: async function() {
      this.loading = true;
      const [error, data] = await userDetailsAdmin(this.$route.params.userId);
      if (error) {
        this.loading = false;
        this.errorMessages = error;
      } else {
        if (data.apiStatus === 200) {
          let newForm = { ...this.form };
          newForm.firstName.value = data.apiData.firstName;
          newForm.lastName.value = data.apiData.lastName;
          newForm.email.value = data.apiData.email;
          newForm.balance.value = data.apiData.balance;
          newForm.phoneNumber.value = data.apiData.phoneNumber;
          newForm.isEmailConfirmed.value = data.apiData.isEmailConfirmed;
          newForm.isPhoneNumberConfirmed.value =
            data.apiData.isPhoneNumberConfirmed;
          this.form = { ...newForm };

          this.isActive = data.apiData.isActive;
          this.role = data.apiData.role;
          this.profilePicture = data.apiData.profilePicture;
          let temp = [...this.profileList];
          temp.map(item => {
            switch (item.id) {
              case "username":
                item["value"] = data.apiData.username;
                break;
              case "registerDateTime":
                item["value"] = data.apiData.registerDateTime;
                break;
              case "lastLoginDateTime":
                item["value"] = data.apiData.lastLoginDateTime;
                break;
            }
          });
          this.profileList = [...temp];
          this.loading = false;
        } else {
          this.loading = false;
          this.errorMessages = data.apiErrors;
        }
      }
    },
    editInfoSubmit: async function() {
      this.loadingEdit = true;
      console.log(this.form);
      // eslint-disable-next-line no-debugger
      debugger;
      const [error, data] = await userEditAdmin({
        userId: this.$route.params.userId,
        firstName: this.form.firstName.value,
        lastName: this.form.lastName.value,
        roleId: this.role,
        email: this.form.email.value,
        balance: this.form.balance.value,
        password: this.form.password.value,
        profilePicture: "",
        isEmailConfirmed: this.form.isEmailConfirmed.value,
        isPhoneNumberConfirmed: this.form.isPhoneNumberConfirmed.value,
        isActive: this.isActive
      });
      if (error) {
        this.loadingEdit = false;
        this.errorMessagesEdit = error;
      } else {
        if (data.apiStatus === 200) {
          this.loadingEdit = false;
          this.$router.push(`/admin/user/${this.$route.params.userId}/details`);
        } else {
          this.loadingEdit = false;
          this.errorMessagesEdit = data.apiErrors;
        }
      }
    },
    balanceChangeHandler: function(val) {
      const reg = /^[0-9]*$/;
      let temp = { ...this.form };
      if (val === "") {
        temp.balance.error = "اعتبار حساب الزامی است.";
        this.validBalance = false;
      } else {
        if (!reg.test(val)) {
          temp.balance.error = "اعتبار حساب باید عددی باشد.";
          this.validBalance = false;
        } else {
          temp.balance.error = "";
          temp.balance.value = val;
          this.validBalance = true;
        }
      }
      this.form = { ...temp };
    },
    passwordChangeHandler: function(val) {
      const preg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
      let temp = { ...this.form };
      if (val === "") {
        temp.password.error = "رمز عبور الزامی است";
        this.validPassword = false;
      } else {
        if (!preg.test(val)) {
          temp.password.error =
            "رمز عبور باید شامل حروف کوچک یا بزرگ انگلیسی، حداقل یک عدد، حداقل یک کاراکتر خاص و حداقل 8 کاراکتر باشد.";
          this.validPassword = false;
        } else {
          temp.password.error = "";
          this.validPassword = true;
          if (temp.password.value !== temp.confirmPassword.value) {
            temp.confirmPassword.error =
              "رمز عبور با تکرار رمز عبور مطابقت ندارد.";
            this.validConfirmPassword = false;
          } else {
            temp.confirmPassword.error = "";
            this.validConfirmPassword = true;
          }
        }
      }
      this.form = { ...temp };
    },
    confirmPasswordChangeHandler: function(val) {
      console.log(this.form);
      if (val === "") {
        this.form.confirmPassword.error = "تکرار رمز عبور الزامی است";
        this.validConfirmPassword = false;
      } else {
        if (this.form.password.value !== this.form.confirmPassword.value) {
          this.form.confirmPassword.error =
            "رمز عبور با تکرار رمز عبور مطابقت ندارد.";
          this.validConfirmPassword = false;
        } else {
          this.form.confirmPassword.error = "";
          this.validConfirmPassword = true;
        }
      }
    },
    emailChangeHandler: function(val) {
      const reg = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let temp = { ...this.form };

      if (val === "") {
        temp.email.error = "ایمیل الزامی است.";
        this.validEmail = false;
      } else {
        if (!reg.test(val)) {
          temp.email.error = "ایمیل وارد شده صحیح نیست.";
          this.validEmail = false;
        } else {
          temp.email.error = "";
          temp.email.value = val;
          this.validEmail = true;
        }
      }
      this.form = { ...temp };
    },
    phoneNumberChangeHandler: function(val) {
      let reg = /(0|\+98|\u06F0)?([ ]|,|-|[()]){0,2}(9|\u06F9)[1|2|3|4|\u06F1|\u06F2|\u06F3|\u06F4]([ ]|,|-|[()]){0,2}(?:[0-9\u06f0-\u06f9]([ ]|,|-|[()]){0,2}){8}/;
      let temp = { ...this.form };
      if (val === "") {
        temp.phoneNumber.error = "تلفن همراه الزامی است.";
        this.validPhoneNumber = false;
      } else {
        if (!reg.test(val)) {
          temp.phoneNumber.error = "شماره تلفن همراه وارد شده صحیح نیست.";
          this.validPhoneNumber = false;
        } else {
          temp.phoneNumber.error = "";
          temp.phoneNumber.value = val;
          this.validPhoneNumber = true;
        }
      }
      this.form = { ...temp };
    },
    firstNameChangeHandler: function(val) {
      let temp = { ...this.form };
      if (val === "") {
        temp.firstName.error = "نام الزامی است.";
        this.validFirstName = false;
      } else {
        temp.firstName.error = "";
        temp.firstName.value = val;
        this.validFirstName = true;
      }
      this.form = { ...temp };
    },
    lastNameChangeHandler: function(val) {
      let temp = { ...this.form };
      if (val === "") {
        temp.lastName.error = "نام خانوادگی الزامی است.";
        this.validLastName = false;
      } else {
        temp.lastName.error = "";
        temp.lastName.value = val;
        this.validLastName = true;
      }
      this.form = { ...temp };
    }
  },
  updated() {
    if (
      this.validEmail &&
      this.validPassword &&
      this.validBalance &&
      this.validFirstName &&
      this.validLastName
    ) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }
};
</script>

<style></style>
